import { isEqual as _isEqual } from 'lodash';
import { isValidElement, memo } from 'react';
/**
 * NOTE:
 * IF `dependencyProps` array is provided => it will check the equality of the specified `prop names` in that array
 * OTHERWISE all props of the component will be tested for equality
 * @param Component
 * @param dependencyProps
 */
export function withMemo<T>(Component: React.FC<T>, dependencyProps?: Array<keyof T>) {
	return memo(Component, (prevProps, nextProps) => {
		let isEqual = true;

		const allPropsCount = Object.keys(prevProps).length;
		const allPropNames = Object.keys(prevProps).map(propName => propName as keyof T);

		const length = dependencyProps ? dependencyProps.length : allPropsCount;

		for (let i = 0; i < length; i++) {
			const propName = dependencyProps ? dependencyProps[i] : allPropNames[i];

			const prevProp = prevProps[propName];
			const nextProp = nextProps[propName];

			// compare equality between functions
			if (typeof prevProp === 'function') {
				if (prevProp !== nextProp) {
					isEqual = false;
					break;
				}
				// react elements cannot be compared
			} else if (isValidElement(prevProp) || isValidElement(nextProp)) {
				isEqual = false;
				break;
				// html elements cannot be compared
			} else if (
				prevProp instanceof HTMLElement ||
				(prevProp && (prevProp as any).current) instanceof HTMLElement ||
				nextProp instanceof HTMLElement ||
				(nextProp && (nextProp as any).current) instanceof HTMLElement
			) {
				isEqual = false;
				return isEqual;
			}

			// compare equality between primitives, arrays, objects...
			else {
				if (JSON.stringify(prevProp) !== JSON.stringify(nextProp)) {
					isEqual = false;
					break;
				}
			}
		}

		return isEqual;
	});
}

export function withMemoOnce<T>(Component: React.FC<T>) {
	return memo(Component, () => true);
}
